import { render, staticRenderFns } from "./BinCard.vue?vue&type=template&id=7501641d"
import script from "./BinCard.vue?vue&type=script&lang=js"
export * from "./BinCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports